import { useReducer } from "react";
import { initialUserState, userReducer } from "./UserReducer";
import { UserContext } from "./UserContext";


export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(userReducer, initialUserState);

  return (
    <UserContext.Provider value={{ state, dispatch }}>
      {children}
    </UserContext.Provider>
  );
};
